import {
  SOCIETE_LISTE_REQUETTE,
  SOCIETE_LISTE_SUCCES,
  SOCIETE_LISTE_ECHEC,
  SOCIETE_ACTUELLE,
  SOCIETE_CREATION_REQUETTE,
  SOCIETE_CREATION_SUCCES,
  SOCIETE_CREATION_ECHEC,
  SOCIETE_UPDATE_REQUETTE,
  SOCIETE_UPDATE_SUCCES,
  SOCIETE_UPDATE_ECHEC,
  SOCIETE_DETAILS_REQUETTE,
  SOCIETE_DETAILS_SUCCES,
  SOCIETE_DETAILS_ECHEC,
} from "../constantes/societeConstantes";

//------------------------------------------------------------------------------------------------------------------
//le reducer est une fonction a deux parametre d'etrée :le state qui specifier l'etat initial et l'action qui a un type et une payload
//le parametre action est une objet qui contient le type de laction et le paylaod
export const listeSocietesReducer = (state = { societes: [] }, action) => {
  //le switch est affecté sur le type de l'action c.a.d suivant le type on change l'etat
  switch (action.type) {
    //si le type =SOCIETE_LISTE_REQUETTE alors a mettre le loading en etat= true
    case SOCIETE_LISTE_REQUETTE:
      return { loading: true };
    //si le type = SOCIETE_LISTE_SUCCES alors mettre le loading en etat false et charger le le variable qui est un tableau dans le state avec les payload qui a eté charger par data a partir d l'action
    case SOCIETE_LISTE_SUCCES:
      return { loading: false, societes: action.payload };
    //si le type =SOCIETE_LISTE_ECHEC alors a mettre le loading en etat false et remplir le variable erreur avec payload qui contient l'erreur
    case SOCIETE_LISTE_ECHEC:
      return { loading: false, erreur: action.payload };
    // par defaut le state reste a l'etat actuel
    default:
      return state;
  }
};
//------------------------------------------------------------------------------------------------------------------

export const societeActuelle = (state = { socActuelle: {} }, action) => {
  switch (action.type) {
    case SOCIETE_ACTUELLE:
      return { socActuelle: action.payload };
    default:
      return state;
  }
};

export const societeCreerReducer = (state = { societe: {} }, action) => {
  switch (action.type) {
    case SOCIETE_CREATION_REQUETTE:
      return { loading: true };
    case SOCIETE_CREATION_SUCCES:
      return { loading: false, societe: action.payload };
    case SOCIETE_CREATION_ECHEC:
      return { loading: false, erreur: action.payload };
    default:
      return state;
  }
};

export const societeUpdateReducer = (state = { societe: {} }, action) => {
  switch (action.type) {
    case SOCIETE_UPDATE_REQUETTE:
      return { loading: true };
    case SOCIETE_UPDATE_SUCCES:
      return { loading: false, succes: true, societe: action.payload };
    case SOCIETE_UPDATE_ECHEC:
      return { loading: false, succes: false, erreur: action.payload };
    default:
      return state;
  }
};

export const detailsSocieteReducer = (state = { societe: {} }, action) => {
  switch (action.type) {
    case SOCIETE_DETAILS_REQUETTE:
      return { loading: true };
    case SOCIETE_DETAILS_SUCCES:
      return { loading: false, societe: action.payload };
    case SOCIETE_DETAILS_ECHEC:
      return { loading: false, errreur: action.payload };
    default:
      return state;
  }
};
